import React from 'react';
import Header from '../components/Header';
import PrivacyPolicy from '../components/PrivacyPolicy';
import Footer from '../components/Footer';

function PrivacyPolicyPage() {
  return (
    <>
      <Header />
      <main>
        <PrivacyPolicy />
      </main>
      <Footer />
    </>
  );
}

export default PrivacyPolicyPage;
